export default "__VITE_ASSET__nUgjWAfQvFuVv2UKhecz1g__"